'use client';

import { Navigation } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import AppImageLink from 'components/imagelink';
import Image from 'next/image';
import { prepareImagePath } from 'services/lib/util';
import { Title } from '../../title';
import { RectangleArrow } from '../../icons/rectangle-arrow';

const ACFPopularTitlesSlider = ({ title, items }) => {
  return (
    <section className="popularPosts px-0">
      {/* Zamiana <Grid> na <div> z Tailwindem dla układu obok siebie */}
      <div className="popularPosts__header mb-4 flex items-center justify-between px-0 xmd:mb-6">
        <Title text={title} className="!mb-0 px-0" />

        <div className="flex items-center gap-2 px-0">
          <div
            id="previousButton"
            className="swiper-button-prev swiper-button-prev-pop relative static mt-0 h-auto w-auto shrink-0 px-0 after:hidden"
          >
            <RectangleArrow />
          </div>
          <div
            id="nextButton"
            className="swiper-button-next swiper-button-next-pop relative static mt-0 h-auto w-auto shrink-0 px-0 after:hidden"
          >
            <RectangleArrow />
          </div>
        </div>
      </div>

      <Swiper
        navigation={{
          prevEl: '.swiper-button-prev-pop',
          nextEl: '.swiper-button-next-pop',
        }}
        modules={[Navigation]}
        spaceBetween={16}
        freeMode={true}
        slidesPerView={'auto'}
        pagination={{ clickable: true }}
        className="px-0"
      >
        {items.map((item, i) => {
          const sourceUrl = item?.image?.node?.sourceUrl;

          return (
            <SwiperSlide className="item px-0" key={i}>
              <div className="cover relative block h-full w-full overflow-hidden px-0">
                {sourceUrl ? (
                  <AppImageLink target="_blank" href={item.link}>
                    <Image
                      src={prepareImagePath(sourceUrl)}
                      alt="Canal+"
                      fill
                      sizes="(max-width: 768px) 85vw, 25vw"
                      className="object-cover px-0"
                    />
                  </AppImageLink>
                ) : (
                  <div className="flex h-full w-full items-center justify-center bg-[#242424] text-white px-0">
                    Brak obrazka
                  </div>
                )}
              </div>
            </SwiperSlide>
          );
        })}
      </Swiper>
    </section>
  );
};

export default ACFPopularTitlesSlider;
